/**
 * Calendar-date helpers for payment dates (#1445).
 *
 * A payment date is a calendar date, not an instant. The server stores it as midnight and
 * GraphQL returns it as an ISO timestamp (e.g. "2026-07-27T00:00:00.000Z"), while a freshly
 * entered row holds "YYYY-MM-DD". Comparing those through `new Date()` depends on the
 * browser's time zone: at or east of UTC, today's date parses to an instant after local
 * midnight and is wrongly rejected as "in the future". These helpers work on the
 * YYYY-MM-DD text instead, which is exactly what the grid displays.
 */

import { todayDateOnly } from "@/helpers/dates";

// Re-exported so payment-date callers get "today" from the same module as the other helpers.
export { todayDateOnly };

/** Returns the YYYY-MM-DD portion of a date string, or the value unchanged if empty. */
export function toDateOnly(value) {
	if (!value || typeof value !== "string") return value;
	return value.substring(0, 10);
}

/**
 * True when the calendar date in `value` is after `today` (both compared as YYYY-MM-DD).
 * Empty values are never "future"; a required-date rule should handle those separately.
 */
export function isFutureDate(value, today) {
	const date = toDateOnly(value);
	if (!date) return false;
	return date > toDateOnly(today);
}
